import { LoadingStatusType } from "@/enums/enums";
import { ToBankAccountList } from "@/service/finance/financeFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Finance extends VuexModule {
  public bankAccountListLoadingStatus = LoadingStatusType.None;
  public bankAccountList: any = [];

  get getAllBankAccountListLoadingStatus(): LoadingStatusType {
    return this.bankAccountListLoadingStatus;
  }

  get getAllBankAccountList(): any {
    return this.bankAccountList;
  }

  @Mutation
  public MutationBankAccountAccountList(bankAccountList: any) {
    this.bankAccountList = bankAccountList;
  }

  @Mutation
  public MutationBankAccountListLoadingStatus(status: LoadingStatusType) {
    this.bankAccountListLoadingStatus = status;
  }

  @Action
  public DoGetAllMainBankAccount(isUseMainDatabase = false) {
    return new Promise((resolve) => {
      if (this.bankAccountListLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("MutationBankAccountListLoadingStatus", LoadingStatusType.Loading);
        API.FinanceService.DoGetAllBankAccount(isUseMainDatabase)
          .then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const bankAccountList = ToBankAccountList(res.data.bankAccountList);
              this.context.commit("MutationBankAccountAccountList", bankAccountList);
            }
            this.context.commit("MutationBankAccountListLoadingStatus", LoadingStatusType.Success);
            resolve("resolved");
          })
          .catch((error) => error);
      } else {
        setTimeout(() => {
          this.context.commit("MutationSetContactModelListLoadingStatus", LoadingStatusType.Success);
          resolve("resolved");
        }, 250);
      }
    });
  }
}
